// extracted by mini-css-extract-plugin
export var brand = "_a8-9";
export var compact = "_a8-6";
export var extraSmall = "_a8-7";
export var icon = "_a8-0";
export var large = "_a8-4";
export var light = "_a8-1";
export var medium = "_a8-5";
export var outline = "_a8-b";
export var primaryDark = "_a8-a";
export var primaryLight = "_a8-8";
export var primaryModern = "_a8-c";
export var success = "_a8-2";
export var successSolid = "_a8-3";